<div class="image-zoom">
  <span class="image-zoom-label" translate>
    i18n.control.imageZoom.zoom
  </span>&nbsp;
  <mat-icon svgIcon="glass-minus"
            (click)="decreaseZoom()"></mat-icon>
  <input type="range" min="0" [max]="MAX_ZOOM"
         (input)="zoomInputChanged($event)"
         value="0" #zoom step="0.01">
  <mat-icon svgIcon="glass-plus"
            (click)="increaseZoom()"></mat-icon>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/image-zoom/image-zoom.component.html